//-================ IMPORTS FOR GENERAL COMPONENT ================-\\
import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';


//-================ IMPORTS FOR SERVICES ================-\\
import { LibraryFINService } from 'src/app/Services/Libraries/General-FIN/library-fin.service';
import { LibraryMasterService } from 'src/app/Services/Libraries/Library-Master/library-master.service';


//-================ IMPORTS FOR CONSTANTS ================-\\

//-================ IMPORTS FOR DEPENDENCIES ================-\\
import moment from 'moment';
import Swal from 'sweetalert2';


//-================ IMPORTS FOR INTERFACES ================-\\
import { Data_Check, Filter_Check_FIN_Reports } from 'src/app/Interfaces/Libraries/Library-FIN-int/Filter_Check_FIN.interface';
import { Download_CPP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Download_ALL_Files.interface';
import { Response_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Response_FIN.interface';
import { Headers_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Headers-CCP.interface';
import { Data_RL_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Data_RL.interface';


@Component({
    selector: 'app-reportslist-lib-fin',
    templateUrl: './reportslist-lib-fin.component.html',
    styleUrls: ['./reportslist-lib-fin.component.scss', '../../../../../Styles/GlobalStyles.css', '../../../../../Styles/ReportListGlobal.css'],
    standalone: false
})
export class ReportslistLibFINComponent implements OnInit {

  //+================== VARIABLES FOR TITLES ==================+\\
  public TitleTypeFIN: string = 'Generales';

  //+================== TYPE FIN ==================+\\
  public OptionsTypeFIN = [
    { value: 4, item: 'Generales' },
    { value: 1, item: 'Aprobados' },
    { value: 2, item: 'Pendientes' },
    { value: 3, item: 'Rechazados' },
  ];

  //+================== VARIABLES FOR HEADERS RL ==================+\\
  public HeadersRL: Headers_CCP[] = [
    { ID: 1, Name: 'Ubicación', Position: 1, Visible: true, Key_Header: 'UBICA' },
    { ID: 1, Name: 'Nombre del Proceso', Position: 1, Visible: true, Key_Header: 'NAMFI' },
    { ID: 1, Name: 'Código', Position: 1, Visible: true, Key_Header: 'CODEF' },
    { ID: 1, Name: 'Objetivo del proceso ', Position: 1, Visible: true, Key_Header: 'DESCR' },
    { ID: 1, Name: 'Revisión', Position: 1, Visible: true, Key_Header: 'NOREV' },
    { ID: 1, Name: 'Contribuidor', Position: 1, Visible: true, Key_Header: 'CONTR' },
    { ID: 1, Name: 'Fecha de carga', Position: 1, Visible: true, Key_Header: 'DACRE' },
    { ID: 1, Name: 'Fecha de aprobación', Position: 1, Visible: true, Key_Header: 'DAEXP' },
    { ID: 1, Name: 'Mgr. Process Owner', Position: 1, Visible: true, Key_Header: 'APPR1' },
    { ID: 1, Name: 'RM & ICS Specialist', Position: 1, Visible: true, Key_Header: 'APPR2' },
    { ID: 1, Name: 'RM & ICS Sr. Mgr.', Position: 1, Visible: true, Key_Header: 'APPR3' },
    { ID: 1, Name: 'Director or CFO', Position: 1, Visible: true, Key_Header: 'APPR4' },
    { ID: 1, Name: 'En revisión con usuario', Position: 1, Visible: true, Key_Header: 'USASS' },
    { ID: 1, Name: 'Usuario que rechazo', Position: 1, Visible: true, Key_Header: 'USREJ' },
    { ID: 1, Name: 'Razón de rechazo', Position: 1, Visible: true, Key_Header: 'REASO' },
    { ID: 1, Name: 'Estatus ', Position: 1, Visible: true, Key_Header: 'STATU' },
  ]

  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';


  //+================== VARIABLES FOR KEY SNAPSHOTS ==================+\\
  public ValueTypeFIN: number = 4;
  private Route_Level: string = '';
  public CurrentLibrarySlug: string = 'fin';
  public CurrentLibraryName: string = 'Processes';
  public ItemLabel: string = 'Procesos';
  public LibraryHeaders: any[] = [];


  //+================== VARIABLES FOR REPORTS LIST ==================+\\
  public Data_Report_List: Data_RL_FIN[] = [];
  public SelectedData_Report_List: Data_RL_FIN[] = [];
  public Load_Page: boolean = false;


  //+================== VARIABLES FOR REGULAR EXPRESION ==================+\\
  private Expression1: RegExp = /[/]+[0-9]+§/


  //+================== SEARCH ==================+\\
  public Filter_RList: string = '';


  //+================== FOR FILTERS ==================+\\
  public Filter_Global_Check: Filter_Check_FIN_Reports = {
    Extension: [],
    Status: [],
    Revision_No: [],
    Approver1_Name: [],
    Approver2_Name: [],
    Approver3_Name: [],
    Approver4_Name: [],
    Approver_Assigned: [],
    Approver_Rejected: [],
    Contributor_Name: [],
  };

  //-========================= SERVICES =========================-\\
  private Service_FIN = inject(LibraryFINService);
  private router = inject(Router);
  private ActivatedRouter = inject(ActivatedRoute);
  private MasterLibraryService = inject(LibraryMasterService);

  constructor() {
    this.ValueTypeFIN = Number(this.ActivatedRouter.snapshot.params['T']);
    this.Route_Level = this.ActivatedRouter.snapshot.params['R'];
  }

  ngOnInit(): void {
    this.ActivatedRouter.paramMap.subscribe(async params => {
      
      const urlSegments = this.router.url.split('/');
      const libIndex = urlSegments.indexOf('Lib');
      if (libIndex !== -1 && urlSegments.length > libIndex + 1) {
        this.CurrentLibrarySlug = urlSegments[libIndex + 1].toLowerCase();
      } else {
        this.CurrentLibrarySlug = 'fin';
      }

      await this.LoadLibraryDisplayName(this.CurrentLibrarySlug);
      this.LoadHeaders(this.CurrentLibrarySlug);
      this.Load_Data(this.ValueTypeFIN, this.Route_Level);
    });
  }

  private LoadHeaders(slug: string): void {
    this.Service_FIN.Get_Headers(slug).subscribe((res: Response_FIN) => {
      this.LibraryHeaders = res.operation || [];
      this.UpdateHeadersRL();
    });
  }

  private UpdateHeadersRL(): void {
    for (const h of this.HeadersRL) {
      const dbHeader = this.LibraryHeaders.find(lh => lh.Key_Header === h.Key_Header);
      
      if (h.Key_Header.startsWith('APPR')) {
        if (dbHeader) {
          h.Name = dbHeader.Name;
          h.Visible = true;
        } else {
          h.Visible = false;
        }
      } else {
        if (dbHeader) {
          h.Name = dbHeader.Name;
          h.Visible = true;
        }
      }
    }
  }

  public GetHeaderName(key: string, defaultName: string): string {
    const header = this.LibraryHeaders.find(h => h.Key_Header === key);
    return header ? header.Name : defaultName;
  }

  private async LoadLibraryDisplayName(slug: string): Promise<void> {
    try {
      if (slug === 'fin' || slug === 'processes') {
        this.CurrentLibraryName = 'Processes';
        this.ItemLabel = 'Procesos';
        return;
      }

      const res: Response_FIN = await firstValueFrom(this.MasterLibraryService.Get_Active_Libraries());
      const library = (res.operation || []).find((item: any) => String(item?.Slug || '').toLowerCase() === slug);
      this.CurrentLibraryName = String(library?.Nombre || slug.toUpperCase());
      this.ItemLabel = 'Documentos';
    } catch {
      this.CurrentLibraryName = slug.toUpperCase();
      this.ItemLabel = 'Documentos';
    }
  }

  //&===================== FUNCTIONS FOR LOAD DATA SERVER =====================&\\

  private async Load_Data(TypeReportFIN: number, Route: string): Promise<void> {
    this.Load_Page = false;

    this.TitleTypeFIN = this.OptionsTypeFIN.find(item => item.value === TypeReportFIN)?.item || '';

    const Loader = document.getElementById('Loader') as HTMLDivElement;
    Loader.classList.add('active');

    try {

      if (Route === 'Root') Route = '';
      if (this.Route_Level === 'Root') this.Route_Level = '';


      const ResGetDataList: Response_FIN = await firstValueFrom(this.Service_FIN.Report_List_FIN({ Path: Route, Status: TypeReportFIN, LibrarySlug: this.CurrentLibrarySlug }))

      if (ResGetDataList.success) {
        this.Data_Report_List = ResGetDataList.operation;
        this.Generate_Filters();
      }


      Loader.classList.remove('active');
      this.Load_Page = true;

    } catch (e) {

      Swal.fire({
        title: 'Ocurrió un error',
        text: '¡Recargue la página, si el problema persiste notifique al supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })

      Loader.classList.remove('active');
      this.Load_Page = true;
    }
  }

  //&===================== END FUNCTIONS FOR LOAD DATA SERVER =====================&\\





  //&===================== FUNCTIONS FOR GENERAL REPORT LIST =====================&\\


  //-================ FUNCTION FOR CLEAN ROUTE ================-\\
  public Clean_Route(Route: string): string {

    const Route_Add: string = '/' + Route;

    const Route_Clean: string = Route_Add.split(this.Expression1).join('/');

    return Route_Clean.replace('/', '');
  }

  //-================ FUNCTION FOR SEE FIN IN LIBRARY ================-\\
  public SeeFINLibrary(Route: string): void {
    if (this.CurrentLibrarySlug === 'fin' || this.CurrentLibrarySlug === 'processes') {
      this.router.navigate([`Dashboard/FIN/FMLibraryFIN/${encodeURIComponent(Route)}`]);
    } else {
      this.router.navigate([`Dashboard/Lib/${this.CurrentLibrarySlug}/FMLibraryFIN/${encodeURIComponent(Route)}`]);
    }
  }

  //-================== FUNCTION FOR CUT CODE ==================-\\
  public Cut_Code(Code: string): string {
    return Code.length > 15 ? Code.slice(0, 15) + '...' : Code;
  }

  //-================== FUNCTION FOR SEE CODE COMPLETE ==================-\\
  public See_Code(Code: string): void {
    Swal.fire({
      title: 'Código',
      text: Code,
      confirmButtonColor: this.ColorConfirm
    })
  }

  //-================== FUNCTION FOR CUT DESCRIPTION ==================-\\
  public Cut_Purpose(Purpose: string): string {
    return Purpose.length > 32 ? Purpose.slice(0, 32) + '...' : Purpose;
  }

  //-================== FUNCTION FOR SEE Purpose COMPLETE ==================-\\
  public See_Purpose(Purpose: string): void {
    Swal.fire({
      title: 'Objetivo del proceso',
      text: Purpose,
      confirmButtonColor: this.ColorConfirm
    })
  }

  //-================== FUNCTION FOR CUT DESCRIPTION ==================-\\
  public Cut_Reason(Reason: string | null): string {
    return Reason === null ? 'Rechazado por administrador' : Reason.length > 32 ? Reason.slice(0, 32) + '...' : Reason;
  }

  //-================== FUNCTION FOR SEE Reason COMPLETE ==================-\\
  public See_Reason(Reason: string | null): void {
    Reason = Reason === null ? 'Rechazado por administrador' : Reason;
    Swal.fire({
      title: 'Razón de rechazo',
      text: Reason,
      confirmButtonColor: this.ColorConfirm
    })
  }

  public Get_Name_Approver(Name: string | null | undefined) {
    return Name === null ? 'No fue requerido' : Name;
  }

  //-================== FUNCTION FOR DATE FORMAT ==================-\\
  public Date_Format(Date: Date | null): string {
    return moment(Date).utc().format('DD/MM/YYYY hh:mm:ss a')
  }

  //-================== FUNCTION FOR DATE FORMAT ==================-\\
  public DateFormat_Approved(Date: string | Date, Status: number): string {
    return Status === 2 ? ("N/A") : (moment(Date).utc().format('DD/MM/YYYY hh:mm:ss a'));
  }

  //-================== FUNCTION TO RETURN STRING STATUS ==================-\\
  public Status_string(Status: number): string {
    switch (Status) {
      case 1: return 'Aprobado';
      case 2: return 'Pendiente';
      case 3: return 'Rechazado';
      case 4: return 'Eliminado';
      default: return '';
    }
  }

  //-================ FUNCTION FOR STATUS TYPE SQUARE ================-\\
  public Status_Type(Status: number): string {

    switch (Status) {
      case 1: return 'Approved';
      case 2: return 'Pending';
      case 3: return 'Reject';
      default: return '';
    }
  }

  //&===================== END FUNCTIONS FOR GENERAL REPORT LIST =====================&\\


  //&===================== FUNCTIONS FOR CARD OPTIONS =====================&\\

  //-================== TYPE REPORT FIN ==================-\\
  public ChangeTypeFIN(): void {
    this.TitleTypeFIN = (this.OptionsTypeFIN.find((item) => (item.value === this.ValueTypeFIN)))?.item!;
    this.Load_Data(this.ValueTypeFIN, this.Route_Level);
  }

  //-================== RELOAD PAGE ==================-\\
  public ReloadPage(): void {
    this.Load_Data(this.ValueTypeFIN, this.Route_Level);
  }

  //-================== REPORT DOWNLOAD PDF ==================-\\
  public async DownloadReportPDF() {

    const ProgressModal = document.getElementById('ProgressModal') as HTMLDivElement;
    ProgressModal.classList.add('active');

    try {

      const ResDownloadPDF: Response_FIN = await firstValueFrom(this.Service_FIN.Generate_RL_PDF_FIN({ Path: this.Route_Level, Status: this.ValueTypeFIN, LibrarySlug: this.CurrentLibrarySlug }));

      if (ResDownloadPDF.success) {

        const URL: string = ResDownloadPDF.operation.URL;
        const File_Name: string = decodeURIComponent(URL).split('/').pop() || '';

        const File_Name_Download: string = `Report_List_${this.TitleTypeFIN}.${File_Name.split('.').pop()}`

        const IsDownload: boolean = await this.Download_File_FIN(URL, File_Name_Download);

        if (IsDownload)
          this.Delete_File_Temp_RL_FIN(File_Name)

      }


    } catch (e) {
      ProgressModal.classList.remove('active');
      Swal.fire({
        title: 'Error al descargar el reporte',
        text: `¡Ocurrió un error al descargar el reporte listado (PDF), inténtelo de nuevo, si el problema persiste notifique a su supervisor!`,
        icon: 'info',
        confirmButtonColor: this.ColorConfirm,
        confirmButtonText: 'Ok',
      })
    }
  }

  //-================== FUNCTION FOR DOWNLOAD REPORT ==================-\\
  private async Download_File_FIN(URL: string, File_Name: string): Promise<boolean> {


    return new Promise((resolve) => {

      const ProgressModal = document.getElementById('ProgressModal') as HTMLDivElement;
      const Progress_Bar_Table = document.getElementById('Progress-Bar-Table') as HTMLElement;
      ProgressModal.classList.add('active');


      this.Service_FIN.Download_File_FIN(URL, File_Name).subscribe((Data_Download: Download_CPP) => {


        if (Data_Download.state === "IN_PROGRESS") {
          Progress_Bar_Table.style.width = Data_Download.progress + '%';
        }

        if (Data_Download.state === "DONE") {

          ProgressModal.classList.remove('active');
          Progress_Bar_Table.style.width = '0%';

          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 1500,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })

          Toast.fire({
            icon: 'success',
            title: 'Reporte descargado!'
          })

          resolve(true)
        }


        if (Data_Download.Status === 404 || Data_Download.Status === 500) {


          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })

          Toast.fire({
            icon: 'error',
            title: '¡Error al descargar el reporte, informe a su supervisor!'
          })

          ProgressModal.classList.remove('active');
          Progress_Bar_Table.style.width = '0%';

          resolve(false);
        }

      })
    })

  }

  //-================== FUNCTION FOR DELETE FILE TEMP ==================-\\
  private async Delete_File_Temp_RL_FIN(File_Name_Delete: string): Promise<void> {
    try {

      const ResDelete: Response_FIN = await firstValueFrom(this.Service_FIN.Delete_RL_Temp_FIN({ Name_File: File_Name_Delete }));

      if (!ResDelete.success) {
        throw "ERROR DELETE TEMP";
      }

    } catch (e) {

      Swal.fire({
        title: 'Error al eliminar archivo temporal',
        text: `¡Ocurrió un error al eliminar archivo temporal del reporte generado, notifique a su supervisor el problema!`,
        icon: 'info',
        confirmButtonColor: this.ColorConfirm,
        confirmButtonText: 'Ok',
      })

    }
  }

  //-================== REPORT DOWNLOAD PDF ==================-\\
  public async DownloadReportXLSX() {

    const ProgressModal = document.getElementById('ProgressModal') as HTMLDivElement;
    ProgressModal.classList.add('active');

    try {

      const ResDownloadXLSX: Response_FIN = await firstValueFrom(this.Service_FIN.Generate_RL_XLSX_FIN({ Path: this.Route_Level, Status: this.ValueTypeFIN, LibrarySlug: this.CurrentLibrarySlug }));

      if (ResDownloadXLSX.success) {

        const URL: string = ResDownloadXLSX.operation.URL;
        const File_Name: string = decodeURIComponent(URL).split('/').pop() || '';

        const File_Name_Download: string = `Report_List_${this.TitleTypeFIN}.${File_Name.split('.').pop()}`

        const IsDownload: boolean = await this.Download_File_FIN(URL, File_Name_Download);

        if (IsDownload)
          this.Delete_File_Temp_RL_FIN(File_Name)

      }


    } catch (e) {
      ProgressModal.classList.remove('active');
      Swal.fire({
        title: 'Error al descargar el reporte',
        text: `¡Ocurrió un error al descargar el reporte listado (XLSX), inténtelo de nuevo, si el problema persiste notifique a su supervisor!`,
        icon: 'info',
        confirmButtonColor: this.ColorConfirm,
        confirmButtonText: 'Ok',
      })
    }
  }



  //&===================== END FUNCTIONS FOR CARD OPTIONS =====================&\\



  //&===================== FUNCTIONS FOR GENERAL COMPONENT =====================&\\

  //-================== FUNCTION FOR FILTERS ==================-\\
  private Generate_Filters(): void {

    this.Filter_Global_Check = {
      Extension: [],
      Status: [],
      Revision_No: [],
      Approver1_Name: [],
      Approver2_Name: [],
      Approver3_Name: [],
      Approver4_Name: [],
      Approver_Assigned: [],
      Approver_Rejected: [],
      Contributor_Name: [],
    };

    for (const FIN of this.Data_Report_List as any) {

      FIN.Date_Created = moment(FIN.Date_Created).utc().toDate();
      FIN.Date_Expiration = moment(FIN.Date_Expiration).utc().toDate();
      FIN.Approver_Rejected = FIN.Approver_Rejected === null ? 'Administrador' : FIN.Approver_Rejected;

      FIN.F_Extension = { Value: FIN.Extension } as Data_Check;
      FIN.F_Status = { Value: FIN.Status } as Data_Check;
      FIN.F_Revision_No = { Value: FIN.Revision_No } as Data_Check;
      FIN.F_Approver1_Name = { Value: FIN.Approver1_Name } as Data_Check;
      FIN.F_Approver2_Name = { Value: FIN.Approver2_Name } as Data_Check;
      FIN.F_Approver3_Name = { Value: FIN.Approver3_Name } as Data_Check;
      FIN.F_Approver4_Name = { Value: FIN.Approver4_Name } as Data_Check;
      FIN.F_Approver_Assigned = { Value: FIN.Approver_Assigned } as Data_Check;
      FIN.F_Approver_Rejected = { Value: FIN.Approver_Rejected } as Data_Check;
      FIN.F_Contributor_Name = { Value: FIN.Contributor_Name } as Data_Check;

      if (!this.Filter_Global_Check.Extension.some(item => item.Value === FIN.Extension) && FIN.Extension !== null) {
        this.Filter_Global_Check.Extension.push({ Value: FIN.Extension })
      }

      if (!this.Filter_Global_Check.Status.some(item => item.Value === FIN.Status) && FIN.Status !== null) {
        this.Filter_Global_Check.Status.push({ Value: FIN.Status })
      }

      if (!this.Filter_Global_Check.Revision_No.some(item => item.Value === FIN.Revision_No) && FIN.Revision_No !== null) {
        this.Filter_Global_Check.Revision_No.push({ Value: FIN.Revision_No })
      }

      if (!this.Filter_Global_Check.Approver1_Name.some(item => item.Value === FIN.Approver1_Name) && FIN.Approver1_Name !== null) {
        this.Filter_Global_Check.Approver1_Name.push({ Value: FIN.Approver1_Name })
      }

      if (!this.Filter_Global_Check.Approver2_Name.some(item => item.Value === FIN.Approver2_Name) && FIN.Approver2_Name !== null) {
        this.Filter_Global_Check.Approver2_Name.push({ Value: FIN.Approver2_Name })
      }

      if (!this.Filter_Global_Check.Approver3_Name.some(item => item.Value === FIN.Approver3_Name) && FIN.Approver3_Name !== null) {
        this.Filter_Global_Check.Approver3_Name.push({ Value: FIN.Approver3_Name })
      }

      if (!this.Filter_Global_Check.Approver4_Name.some(item => item.Value === FIN.Approver4_Name) && FIN.Approver4_Name !== null) {
        this.Filter_Global_Check.Approver4_Name.push({ Value: FIN.Approver4_Name })
      }

      if (!this.Filter_Global_Check.Approver_Assigned.some(item => item.Value === FIN.Approver_Assigned) && FIN.Approver_Assigned !== null) {
        this.Filter_Global_Check.Approver_Assigned.push({ Value: FIN.Approver_Assigned })
      }

      if (!this.Filter_Global_Check.Approver_Rejected.some(item => item.Value === FIN.Approver_Rejected) && FIN.Approver_Rejected !== null) {
        this.Filter_Global_Check.Approver_Rejected.push({ Value: FIN.Approver_Rejected })
      }

      if (!this.Filter_Global_Check.Contributor_Name.some(item => item.Value === FIN.Contributor_Name) && FIN.Contributor_Name !== null) {
        this.Filter_Global_Check.Contributor_Name.push({ Value: FIN.Contributor_Name })
      }

    }


  }

  //&===================== END FUNCTIONS FOR GENERAL COMPONENT =====================&\\
}
